import { IEduMenu } from './../entities/Menu';
import { SET_MENU, TOGGLE_IS_DATA_FETCHING } from "../actions/adminActions"

type InitialStateType = {
    menu: IEduMenu[]
    isDataFetching: boolean
}

let initialState: InitialStateType = {
    menu: [],
    isDataFetching: false
}

const adminReducer = (state = initialState, action: any): InitialStateType => {
    switch(action.type) {
        case SET_MENU: 
            return {...state, menu: action.menu}
        case TOGGLE_IS_DATA_FETCHING:
            return {...state, isDataFetching: action.isFetching}
        default:
            return state
    }
}

export default adminReducer